<template>
  <div style="padding-bottom: 20px">
    <div class="container adAgreement">
      <div class="first-party">
        <van-field
          value="广东哈弗石油能源股份有限公司"
          label="甲方名称"
          disabled
        />
        <van-field
          required
          v-model.trim="agreementContent.partyAName"
          label="乙方(代理商)"
          placeholder="请输入代理商营业执照名称"
          :disabled="partyAName ? true : false"
        />
        <div class="module-title">丙方信息</div>
        <van-field
          v-model.trim="agreementContent.partyBName"
          label="丙方(门店)"
          placeholder="请输入门店营业执照名称"
        />
        <van-field
          required
          v-model.trim="agreementContent.partyBRealName"
          label="负责人姓名"
          placeholder="请输入负责人姓名"
        />
        <van-field
          required
          v-model.trim="agreementContent.partyBPhone"
          label="负责人手机号"
          placeholder="请输入负责人手机号"
          type="number"
          maxlength="11"
        />
        <div class="tips">(非常重要,请再三确认)</div>
        <van-field
          readonly
          clickable
          name="picker"
          :value="idType"
          label="证件类型"
          placeholder="请选择"
          @click="idTypePicker = true"
        />
        <div class="papers-img">
          <p class="title">营业执照</p>
          <div class="edit-img" v-if="agreementContent.idNoImage">
            <van-image
              width="88"
              height="88"
              fit="contain"
              :src="$imgPath + agreementContent.idNoImage"
              @click="previewImg"
            >
            </van-image>
            <van-icon name="clear" @click="beforeDelete" />
          </div>
          <van-uploader
            v-model="fileList"
            v-if="!agreementContent.idNoImage"
            multiple
            :max-count="1"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            :before-read="beforeRead"
          />
        </div>
        <van-field
          v-model.trim="agreementContent.idNo"
          label="证件号码"
          v-if="idType === '身份证'"
          maxlength="18"
          placeholder="请输入证件号码"
        />
        <van-field
          v-model.trim="agreementContent.idNo"
          label="证件号码"
          maxlength="18"
          placeholder="请输入证件号码"
          v-if="idType === '营业执照'"
        />
        <van-field
          required
          class="van-ellipsis"
          v-model="agreementContent.advertAddress"
          label="广告位置"
          right-icon="location"
          placeholder="点击图标定位"
          @click-right-icon="handleAdress"
        />
        <van-field
          required
          readonly
          clickable
          name="picker"
          :value="agreementContent.finishAt"
          label="完成时间"
          placeholder="请选择"
          @click="showdatetime = true"
        />
      </div>
      <div class="module-title">丙方义务</div>
      <div class="second-party">
        <div class="min-operation-years">
          <span>连续经营哈弗润滑油不少于</span>
          <input
            type="number"
            v-model.trim="agreementContent.minOperationYears"
          />
          <span>年</span>
        </div>
        <div class="min-product-value">
          <span>进货哈弗产品总价值不低于</span>
          <input type="number" v-model.trim="minPurchaseValue" />
          <span>万元</span>
        </div>
        <div class="first-purchase-value">
          <span>首批进货总价值不低于</span>
          <input
            type="number"
            v-model.trim="agreementContent.firstPurchaseValue"
          />
          <span>元</span>
        </div>
        <div class="latest-date">
          <span>首批进货最迟截止日期</span>
          <span>{{ agreementContent.firstLatestPurchaseDate }}</span>
        </div>
      </div>
      <div class="module-title">广告报销方式</div>
      <div v-for="(item, index) in refundArr" :key="index" class="refund">
        丙方<span style="color: black" v-if="index == 0">首批</span>
        <span style="color: black" v-if="index != 0">再次</span>进货<span
          style="color: black"
          v-if="index != 0"
          >并累计</span
        >满
        <span>
          {{
            item.stockPrice > 10000
              ? item.stockPrice / 10000 + "万"
              : item.stockPrice
          }} </span
        >元时,甲方<span style="color: black" v-if="index != 0">再</span>报销
        <span>{{ item.refund }}</span> 元
      </div>
      <div class="remark">
        备注：实际广告报销费用以哈弗公司财务部最终核算的金额为准
      </div>
      <van-button type="primary" @click="handlerSubmit">预览</van-button>
    </div>
    <van-popup v-model="idTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="idTypeColumns"
        @confirm="onIdType"
        @cancel="idTypePicker = false"
      />
    </van-popup>
    <van-popup v-model="showdatetime" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDate"
        @cancel="showdatetime = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import { getQueryObject } from "../../utils";
import { ImagePreview } from "vant";
import * as imageConversion from "image-conversion";
export default {
  data() {
    return {
      idTypeColumns: ["营业执照", "身份证"],
      idTypePicker: false,
      idType: "",
      showdatetime: false,
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      partyAName: JSON.parse(sessionStorage.getItem("userInfo"))
        .businessLicenseName,
      agreementContent: {
        partyAName: JSON.parse(sessionStorage.getItem("userInfo"))
          .businessLicenseName,
        partyBName: "",
        partyBRealName: "",
        partyBPhone: "",
        idType: "",
        idNo: "",
        idNoImage: "",
        advertAddress: "",
        advertLatitude: "",
        advertLongitude: "",
        finishAt: "",
        minOperationYears: "",
        minPurchaseValue: "",
        firstPurchaseValue: "",
        firstLatestPurchaseDate: "",
        reimbursementMethod: [],
        reimbursementMethodDesc: "",
        productBrand: localStorage.getItem("productBrand"),
        estimateTotalCost: localStorage.getItem("estimateTotalCost"),
        contents: [],
      },
      minimum: {
        minOperationYears: 0,
        minPurchaseValue: 0,
        firstPurchaseValue: 0,
      },
      allStockPrice: 0,
      minPurchaseValue: "",
      refundArr: [],
      subStatus: false,
      ratio: 3,
      fileList: [],
    };
  },
  mounted() {
    let that = this;
    window.addEventListener("pagehide", () => {
      that.filterData();
      that.handleSessionStorage();
    });
    let adressInfo = getQueryObject();
    let renderData = JSON.parse(localStorage.getItem("apply"));
    if (this.$route.query.type === "edit") {
      this.agreementContent = renderData;
      this.agreementContent.productBrand = localStorage.getItem("productBrand");
      this.agreementContent.estimateTotalCost =
        localStorage.getItem("estimateTotalCost");
      if (renderData.idType) {
        this.idType = renderData.idType === 1 ? "身份证" : "营业执照";
      }
      this.handleForm();
    } else {
      // 是否有历史记录
      if (renderData) {
        this.agreementContent = renderData;
        this.refundArr = JSON.parse(renderData.reimbursementMethod);
        this.allStockPrice = localStorage.getItem("allStockPrice");
        this.ratio = localStorage.getItem("ratio");
        this.minimum = JSON.parse(localStorage.getItem("minimum"));
        this.minPurchaseValue = renderData.minPurchaseValue / 10000;
        if (renderData.idType) {
          this.idType = renderData.idType === 1 ? "身份证" : "营业执照";
        }
      } else {
        this.handleForm();
      }
      // 是否有定位
      if (adressInfo.addr) {
        this.getAdress(adressInfo);
      }
    }
  },
  methods: {
    // 证件类型
    onIdType(value, index) {
      this.idType = value;
      this.agreementContent.idType = index === 0 ? 2 : 1;
      this.idTypePicker = false;
    },
    // 定位
    handleAdress() {
      this.filterData();
      // 跳转前存储输入内容
      this.handleSessionStorage();
      // 地图选点第二种调用方式
      window.location.href = `https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=${this.$mapBackurl}&key=OG4BZ-GTFW6-TVPS5-EOESI-BR7GV-7KFYZ&referer=myapp`;
    },
    // 解析定位
    getAdress(adressInfo) {
      let latng = adressInfo.latng;
      this.agreementContent.advertAddress = adressInfo.addr;
      this.agreementContent.advertLatitude = parseFloat(latng.split(",")[0]);
      this.agreementContent.advertLongitude = parseFloat(latng.split(",")[1]);
    },
    // 时间选择
    onDate(value) {
      var m = value.getMonth() + 1;
      var d = value.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = value.getFullYear() + "-" + m + "-" + d;
      this.agreementContent.finishAt = timer;
      this.showdatetime = false;
      this.abortData(value);
    },
    // 截止日期
    abortData(value) {
      value.setDate(value.getDate() + 10);
      var m = value.getMonth() + 1;
      var d = value.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = value.getFullYear() + "-" + m + "-" + d;
      this.agreementContent.firstLatestPurchaseDate = timer;
    },
    // 提交
    handlerSubmit() {
      this.subStatus = true;
      if (!this.handleRules()) {
        this.subStatus = false;
        return;
      }
      this.filterData();
      this.handleSessionStorage();
      this.$router.push("/agency/preview");
    },
    // 表单检验
    handleRules() {
      if (!this.partyAName) {
        if (
          !/[\u4e00-\u9fa5]/gm.test(this.agreementContent.partyAName.trim())
        ) {
          this.$toast("营业执照请输入中文");
          return false;
        }
      } else {
        this.$toast("请输入乙方(代理商)");
      }
      if (
        !/[\u4e00-\u9fa5]/gm.test(this.agreementContent.partyBRealName.trim())
      ) {
        this.$toast("姓名请输入中文");
        return false;
      }
      if (
        this.agreementContent.partyBPhone.trim() === "" ||
        !/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
          this.agreementContent.partyBPhone.trim()
        )
      ) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      if (this.agreementContent.advertAddress === "") {
        this.$toast("请进行定位或输入位置");
        return false;
      }
      if (this.agreementContent.finishAt.trim() === "") {
        this.$toast("请选择完成时间");
        return false;
      }
      if (this.agreementContent.minOperationYears.toString().trim() === "") {
        this.$toast("请输入丙方经营年限");
        return false;
      }
      console.log(this.minPurchaseValue.toString().trim());
      if (this.minPurchaseValue.toString().trim() === "") {
        this.$toast("请输入丙方进货价值");
        return false;
      }
      if (this.agreementContent.firstPurchaseValue.toString().trim() === "") {
        this.$toast("请输入首次进货价值");
        return false;
      }
      if (
        this.agreementContent.minOperationYears < this.minimum.minOperationYears
      ) {
        this.$toast(`经营年限不得低于${this.minimum.minOperationYears}年`);
        return false;
      }
      if (this.minPurchaseValue < this.minimum.minPurchaseValue) {
        this.$toast(`总进货价值不得低于${this.minimum.minPurchaseValue}万元`);
        return false;
      }
      if (
        this.agreementContent.firstPurchaseValue <
        this.minimum.firstPurchaseValue
      ) {
        this.$toast(`首次进货价值不得低于${this.minimum.firstPurchaseValue}元`);
        return false;
      }
      return true;
    },
    // 表单渲染
    handleForm() {
      let vm = this;
      // 遍历经销商所选材质计算最低年限
      let materialQualityArr = [];
      JSON.parse(localStorage.getItem("content")).forEach((val) => {
        materialQualityArr.push(val.materialQuality);
      });
      if (materialQualityArr.includes(3) || materialQualityArr.includes(4)) {
        vm.agreementContent.minOperationYears = 3;
        vm.minimum.minOperationYears = 3;
      } else if (materialQualityArr.includes(2)) {
        vm.agreementContent.minOperationYears = 2;
        vm.minimum.minOperationYears = 2;
      } else {
        vm.agreementContent.minOperationYears = 1;
        vm.minimum.minOperationYears = 1;
      }
      // 遍历经销商所选材质计算进货量比率
      JSON.parse(localStorage.getItem("content")).forEach((val) => {
        if (val.materialQuality > 2) {
          this.ratio = 8;
          return;
        }
      });
      // 计算总进货量
      vm.allStockPrice = Math.ceil(
        vm.agreementContent.estimateTotalCost / 0.04
      );
      vm.minimum.minPurchaseValue = vm.allStockPrice / 10000;
      vm.minPurchaseValue = vm.allStockPrice / 10000;
      // 首次进货量
      vm.agreementContent.firstPurchaseValue = Math.ceil(
        (vm.allStockPrice / (12 * vm.agreementContent.minOperationYears)) *
          this.ratio
      );
      vm.minimum.firstPurchaseValue = vm.agreementContent.firstPurchaseValue;
      // 报销方式
      for (let i = 0; i < Math.ceil(vm.allStockPrice / 100000); i++) {
        let tempArr = {
          stockPrice: 0,
          refund: 0,
        };
        if (i === 0) {
          tempArr.stockPrice = vm.agreementContent.firstPurchaseValue;
          tempArr.refund =
            vm.agreementContent.estimateTotalCost > 5000
              ? 5000
              : vm.agreementContent.estimateTotalCost;
          vm.refundArr.push(tempArr);
        } else {
          tempArr.stockPrice =
            vm.allStockPrice > 100000 * i ? 100000 * i : vm.allStockPrice;
          tempArr.refund =
            vm.agreementContent.estimateTotalCost - 5000 * i > 5000
              ? 5000
              : vm.agreementContent.estimateTotalCost - 5000 * i;
          if (tempArr.refund <= 0) {
            return;
          }
          vm.refundArr.push(tempArr);
        }
      }
    },
    // 数据过滤
    filterData() {
      // 进货总价值
      this.agreementContent.minPurchaseValue = Math.ceil(
        this.minPurchaseValue * 10000
      );
      // 报销方式
      this.agreementContent.reimbursementMethod = JSON.stringify(
        this.refundArr
      );
      // 广告内容
      this.agreementContent.contents = JSON.parse(
        localStorage.getItem("content")
      );
      // 报销方式
      this.agreementContent.reimbursementMethodDesc = "";
      this.refundArr.forEach((val, index) => {
        this.agreementContent.reimbursementMethodDesc += `丙方${
          index == 0 ? "首批" : "再次"
        }进货${index == 0 ? "" : "并累计"}满${
          val.stockPrice > 10000
            ? val.stockPrice / 10000 + "万"
            : val.stockPrice
        }元时,甲方${index == 0 ? "" : "再"}报销${val.refund}元;  `;
      });
    },
    // 存储数据
    handleSessionStorage() {
      localStorage.setItem("apply", JSON.stringify(this.agreementContent));
      localStorage.setItem("minimum", JSON.stringify(this.minimum));
      localStorage.setItem("allStockPrice", this.allStockPrice);
      localStorage.setItem("ratio", this.ratio);
    },
    // 上传图片前
    beforeRead(file) {
      if (file.type != "image/png" && file.type != "image/jpeg") {
        this.$toast("请上传png、jpeg图片格式");
        return false;
      }
      return new Promise((resolve) => {
        const isLt2M = file.size / 1024 < 900;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 900).then((res) => {
            let files = new window.File([res], file.name, {
              type: file.type,
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then((res) => {
          // console.log(res);
          file.status = "done";
          file.message = "上传成功";
          // this.adContent.realSceneImg.push(res.url);
          this.agreementContent.idNoImage = res.url;
        })
        .catch((err) => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          Toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete() {
      // this.fileList.splice(detail.index, 1);
      // this.adContent.realSceneImg.splice(detail.index, 1);
      this.fileList = [];
      this.agreementContent.idNoImage = "";
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    },
  },
  beforeDestroy() {
    this.filterData();
    this.handleSessionStorage();
  },
};
</script>
<style lang="scss" scoped>
.van-steps--horizontal {
  padding: 0;
}

.container {
  padding-top: 10px;

  .module-title {
    padding: 5px 0;
    background-color: #ccc;
  }

  .second-party {
    div {
      display: flex;
      align-items: center;
      padding: 10px 0;

      span {
        text-align: left;
        font-size: 14px;
      }

      input {
        width: 80px;
        text-indent: 10px;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid #000;
      }
    }

    .first-purchase-value {
      input {
        width: 100px;
      }
    }

    .min-operation-years {
      input {
        width: 40px;
      }
    }

    .latest-date {
      span:first-child {
        margin-right: 5px;
      }

      span:last-child {
        display: inline-block;
        border-bottom: 1px solid #000;
        font-size: 16px;
      }
    }
  }

  .second-party {
    padding: 0 20px;
  }

  .tips {
    padding: 0 20px;
    text-align: left;
    font-size: 12px;
    color: red;
  }

  .papers-img {
    padding: 10px 20px;
    text-align: left;
    color: #646566;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;

    .title {
      margin-right: 70px;
    }

    .van-image {
      margin-right: 5px;
    }

    .edit-img {
      position: relative;

      .van-icon {
        position: absolute;
        top: 0;
        right: 5px;
        color: #969799;
        font-size: 18px;
      }
    }
  }

  .refund {
    padding: 10px 20px;
    text-align: left;
    font-size: 14px;

    span {
      color: red;
    }
  }

  .remark {
    margin-bottom: 20px;
    padding: 0 20px;
    text-align: left;
    color: red;
    font-size: 14px;
  }
}

.min-operation-years::before,
.min-product-value::before,
.first-purchase-value::before,
.latest-date::before {
  position: absolute;
  left: 8px;
  color: #ee0a24;
  font-size: 14px;
  content: "*";
}

.van-cell:not(:last-child)::after {
  display: none;
}

.van-step {
  text-align: left;
}

.van-cell {
  padding: 10px 20px;
}
</style>
<style lang="scss">
.adAgreement {
  .van-steps--horizontal .van-steps__items {
    margin-bottom: 0;
  }

  .van-field__label {
    flex: 1;
    text-align: left;
    font-weight: 600;
  }

  .van-cell__value {
    flex: 2;
  }

  .van-field__control {
    border-bottom: 1px solid #000;
    text-indent: 10px;
  }

  .van-field__control:disabled {
    color: #000;
  }
}
</style>
